import { Link } from "react-router-dom";
import SearchBar from "../SearchBar";
import TableMed from "../TableMed";
import Loading from "../../utils/Loading";
import { getMagiccodes } from "../../actions/acc_actions";
import { useQuery } from "@tanstack/react-query";

export default function Magiccode({ accUrn }) {
  const { isLoading, data } = useQuery({
    queryKey: ["magiccodes", accUrn],
    queryFn: () => getMagiccodes(accUrn),
    enabled: accUrn ? true : false,
  });

  if (isLoading) return <Loading />;

  const columns = [
    {
      title: "Name",
      render: (item) => item?.data?.name,
    },
    {
      title: "Account",
      render: (item) => item?.data?.account_slug,
    },
    {
      title: "Created At",
      dataIndex: "created_at",
    },
    {
      title: "Start At",
      render: (item) => item?.data?.start,
    },
    {
      title: "Expire At",
      render: (item) => item?.data?.expiry,
    },
  ];
  return (
    <div className="features-tab">
      <div className="form-row">
        <Link to="create" className="btn primary">
          Create
        </Link>
      </div>
      <TableMed data={data?.data} columns={columns} />
    </div>
  );
}
